@if (loadingService.isLoading$ | async) {
  <div class="overlay">
    <mat-progress-spinner mode="indeterminate" diameter="60" color="primary"></mat-progress-spinner>
  </div>
}
